var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 100,
    viewBox: "0 0 108 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8201 70.55V74.46",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8601 72.5H16.7701",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2 0.949951V4.85995",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.25 2.91003H43.16",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.01 7.41003V11.32",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.05 9.37H87.96",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7601 10.3499C67.2516 10.3499 67.6501 9.95148 67.6501 9.45995C67.6501 8.96841 67.2516 8.56995 66.7601 8.56995C66.2686 8.56995 65.8701 8.96841 65.8701 9.45995C65.8701 9.95148 66.2686 10.3499 66.7601 10.3499Z",
    fill: "#3B0069",
    fillOpacity: 0.521569
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.15 27.77C98.6415 27.77 99.04 27.3715 99.04 26.88C99.04 26.3885 98.6415 25.99 98.15 25.99C97.6585 25.99 97.26 26.3885 97.26 26.88C97.26 27.3715 97.6585 27.77 98.15 27.77Z",
    fill: "#3B0069",
    fillOpacity: 0.521569
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3199 89.33C59.8115 89.33 60.2099 88.9316 60.2099 88.44C60.2099 87.9485 59.8115 87.55 59.3199 87.55C58.8284 87.55 58.4299 87.9485 58.4299 88.44C58.4299 88.9316 58.8284 89.33 59.3199 89.33Z",
    fill: "#3B0069",
    fillOpacity: 0.521569
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5199 17.19C29.0114 17.19 29.4099 16.7916 29.4099 16.3C29.4099 15.8085 29.0114 15.41 28.5199 15.41C28.0283 15.41 27.6299 15.8085 27.6299 16.3C27.6299 16.7916 28.0283 17.19 28.5199 17.19Z",
    fill: "#3B0069",
    fillOpacity: 0.521569
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8 37.65C65.18 37.65 57.44 37.34 50.2 35.33C42.96 33.32 36.6 29.53 30.74 25.1C26.93 22.21 23.45 19.92 18.52 20.27C13.6848 20.5274 9.06045 22.3329 5.33005 25.42C-0.999955 30.93 4.36306e-05 41.12 2.50004 48.28C6.28004 59.08 17.79 66.57 27.57 71.46C38.87 77.1 51.28 80.38 63.73 82.27C74.73 83.93 88.66 85.13 98.11 78C106.8 71.46 109.18 56.51 107.05 46.42C106.535 43.4379 104.949 40.7463 102.59 38.85C96.49 34.39 87.39 37.37 80.53 37.52C78 37.58 75.4 37.64 72.8 37.65Z",
    fill: "#3B0069",
    fillOpacity: 0.44
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1801 99.95C72.6098 99.95 87.5501 99.0188 87.5501 97.87C87.5501 96.7213 72.6098 95.79 54.1801 95.79C35.7503 95.79 20.8101 96.7213 20.8101 97.87C20.8101 99.0188 35.7503 99.95 54.1801 99.95Z",
    fill: "#3B0069",
    fillOpacity: 0.44
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6599 30.77H23.4099V82.12H29.6599V30.77Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8999 30.77H78.6499V82.12H84.8999V30.77Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.28 30.77H51.03V82.12H57.28V30.77Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M89.02 78.8101H19.28V83.6901H89.02V78.8101Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M89.02 31.83H19.28V36.71H89.02V31.83Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4599 32.08L54.1799 8.92004L14.8899 32.08H93.4599Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54.45 29.13C58.4099 29.13 61.62 25.9199 61.62 21.96C61.62 18.0002 58.4099 14.79 54.45 14.79C50.4901 14.79 47.28 18.0002 47.28 21.96C47.28 25.9199 50.4901 29.13 54.45 29.13Z",
    fill: "#3B0069",
    fillOpacity: 0.76
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1101 26.64V25.49C53.4889 25.4961 52.8787 25.3262 52.3501 25L52.6101 24.24C53.1026 24.554 53.6761 24.7173 54.2601 24.71C55.0701 24.71 55.6101 24.23 55.6001 23.58C55.5901 22.93 55.1501 22.58 54.3001 22.24C53.1401 21.79 52.4101 21.24 52.4001 20.24C52.4029 19.7745 52.5783 19.3267 52.8924 18.9831C53.2064 18.6395 53.6367 18.4246 54.1001 18.38V17.28H54.8101V18.39C55.3305 18.3917 55.8425 18.5222 56.3001 18.77L56.0201 19.53C55.5846 19.2734 55.0854 19.1451 54.5801 19.16C53.7001 19.16 53.3801 19.69 53.3801 20.16C53.3801 20.63 53.8101 21.04 54.8101 21.44C55.9901 21.91 56.5801 22.5 56.5901 23.51C56.5931 24.0045 56.4128 24.4825 56.0841 24.8518C55.7554 25.2212 55.3015 25.4556 54.8101 25.51V26.69L54.1101 26.64Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.533589a5d4d8dae5a752a0a66bbcc2d6.svg";
export { ForwardRef as ReactComponent };